import "./styles.css";
import { Box, Grid, Container, CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
// import LoginImage from "./images/login.svg";
import InputTextfield from "../../../../shared/components/textField";
import { getValidationSchema } from "../../../../shared/validations/schema";
// import Logo from "../../../../shared/components/logo";
import useMutation from "../../../../shared/components/hooks/useMutation";
import ForgotImg from "../../../../assets/img/forgot-text.svg";
import ForgotBg from "../../../../assets/img/forgot-bg.svg";
import GcomLogo from "../../../../assets/img/dashboard-title.svg";
import { useNavigate } from "react-router-dom";
import login_bg from "../../../../assets/img/login_bg.jpg";
import { clearLocalStorageData } from "../../../../shared/utils/localStorage";

const App = () => {
  const { loading, modifyData } = useMutation();
  const navigate = useNavigate();

  const textFields = [
    {
      id: "email",
      name: "email",
      label: "Email",
      placeholder: "Enter your email address",
      type: "text",
    },
  ];

  const forgotPasswordForm = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: getValidationSchema(["email"]),
    onSubmit: async (formData: any) => {
      const response = await modifyData(
        `/user/forgot-password`,
        "post",
        formData
      );
      if (response) forgotPasswordForm.resetForm();
    },
  });

  const handleCancelClick = () => {
    clearLocalStorageData();
    navigate("/login");
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: `url(${login_bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Box className="menuContainer">
            <Grid container>
              <Grid item md={2.5} xs={8}>
                <img src={GcomLogo} alt="" />
              </Grid>
            </Grid>
          </Box>
          <img className="forgot-bg" src={ForgotBg} alt="" />
          <Box sx={{ padding: "0.5% 12% 4% 12%" }}>
            <Grid container justifyContent="flex-end">
              {" "}
              <Grid item md={6} className="loginGridWrapper">
                <img src={ForgotImg} className="forgot-img" alt="" />
                {/* <div className="leftCircle"></div> */}

                <div className="loginGridContainer">
                  <form
                    onSubmit={forgotPasswordForm.handleSubmit}
                    autoComplete="off"
                    className="forgotPasswordForm"
                  >
                    <InputTextfield
                      className="mediumInputBox"
                      form={forgotPasswordForm}
                      fieldProps={textFields[0]}
                    />
                    <div className="infoText">
                      We’ll send a password reset link to your registered email.
                    </div>
                    <Grid
                      container
                      sx={{ alignItems: "center", justifyContent: "flex-end" }}
                    >
                      {/* <Grid item md={12} className="infoText">
                        We’ll send a password reset link to your registered
                        email.
                      </Grid> */}
                      <Grid
                        item
                        md={3}
                        className="cancelButton"
                        onClick={handleCancelClick}
                        role="button"
                        tabIndex={0}
                        style={{ cursor: "pointer" }}
                      >
                        Cancel
                      </Grid>
                      <Grid item md={5}>
                        <LoadingButton
                          className="signInButton"
                          loading={loading}
                          loadingIndicator={
                            <CircularProgress
                              size={22}
                              sx={{ color: "white" }}
                            />
                          }
                          variant="contained"
                          type="submit"
                          fullWidth
                          size="large"
                        >
                          <span
                            style={{
                              visibility: loading ? "hidden" : "visible",
                            }}
                          >
                            Send Link
                          </span>
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  </form>
                </div>
                {/* <div className="rightCircle"></div> */}
              </Grid>
              <Grid item md={0.85}></Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default App;
